
  document.addEventListener("DOMContentLoaded", function () {
    new Swiper(".categorySlider", {
      slidesPerView: 2,
      spaceBetween: 20,
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      breakpoints: {
        768: { slidesPerView: 2 },
        576: { slidesPerView: 1 },
      },
    });
  });
  
  document.addEventListener("DOMContentLoaded", function () {
    if (typeof Swiper !== 'undefined') {
      new Swiper(".product-slider", {
        slidesPerView: 4,
        spaceBetween: 30,
        loop: true,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        breakpoints: {
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
          1200: { slidesPerView: 4 }
        }
      });
    }
  });

  // testimonial slider
  document.addEventListener('DOMContentLoaded', function () {
    new Swiper(".testimonialSwiper", {
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 2,
        }
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function() {
    // Initialize thumbnail slider only if it exists
    let thumbnailSlider = null;
    const thumbnailEl = document.querySelector('.thumbnail-slider');
    if (thumbnailEl) {
      thumbnailSlider = new Swiper('.thumbnail-slider', {
        loop: true,
        spaceBetween: 10,
        slidesPerView: 4,
        freeMode: true,
        watchSlidesProgress: true,
      });
    }
  
    // Main slider configuration
    const mainSliderOptions = {
      loop: true,
      spaceBetween: 10,
      navigation: {
        nextEl: '.main-slider .swiper-button-next',
        prevEl: '.main-slider .swiper-button-prev',
      }
    };
  
    // Add thumbs only if thumbnail slider exists
    if (thumbnailSlider) {
      mainSliderOptions.thumbs = { swiper: thumbnailSlider };
    }
  
    // Initialize main slider
    new Swiper('.main-slider', mainSliderOptions);
  
    // Related products slider
    const relatedProductsSlider = new Swiper('.related-products-slider', {
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: '.related-products-slider .swiper-button-next',
        prevEl: '.related-products-slider .swiper-button-prev',
      },
      breakpoints: {
        576: { slidesPerView: 2 },
        768: { slidesPerView: 3 },
        992: { slidesPerView: 4 }
      }
    });
  });